import {useLayoutState} from "../../store/layout.js";
import {useSize} from "../../../__snowpack__/pkg/ahooks.js";
import {Pagination} from "../../../__snowpack__/pkg/antd.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import React, {useContext, useEffect, useRef, useState} from "../../../__snowpack__/pkg/react.js";
import ReactDOM from "../../../__snowpack__/pkg/react-dom.js";
import {TabPaneContext} from "./TabPane.js";
export default function Footer(props) {
  const {pagination, onPageChange, justify, contentStyle, children, ...restProps} = props;
  const {layoutState} = useLayoutState();
  const tabPaneContext = useContext(TabPaneContext);
  const ref = useRef(null);
  const [simplePagination, setSimplePagination] = useState(false);
  const vacantSpaceRef = useRef(null);
  const size = useSize(vacantSpaceRef);
  useEffect(() => {
    if (!simplePagination && size?.width === 0) {
      setSimplePagination(true);
    } else if (simplePagination && (size?.width ?? 0) > 400) {
      setSimplePagination(false);
    }
  }, [size?.width]);
  const alignStyles = !!justify ? {
    justifyContent: justify,
    flex: 999999
  } : {};
  const container = ref?.current?.closest(".page-container");
  const shouldShowFooter = (tabPaneContext?.isActivated ?? true) && !!container;
  return /* @__PURE__ */ React.createElement("div", {
    ref
  }, shouldShowFooter && ReactDOM.createPortal(/* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    ...restProps,
    className: classNames("page-container-footer", props.className),
    style: {
      left: layoutState.sideWidth,
      ...restProps.style
    }
  }, /* @__PURE__ */ React.createElement("div", {
    className: "page-container-footer-content",
    style: {...alignStyles, ...contentStyle}
  }, children), /* @__PURE__ */ React.createElement("div", {
    ref: vacantSpaceRef,
    style: {flex: pagination ? 1 : void 0}
  }), pagination && /* @__PURE__ */ React.createElement(Pagination, {
    simple: simplePagination,
    showSizeChanger: true,
    ...pagination,
    onChange: (...args) => {
      window.scrollTo({top: 0, behavior: "smooth"});
      pagination?.onChange(...args);
      onPageChange?.(...args);
    }
  })), /* @__PURE__ */ React.createElement("div", {
    className: "page-container-footer-placeholder"
  })), container));
}
